import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { LoopPlannerScenarioApi } from '@/lib/api/loop-planner/scenario';
import { loopPlannerQueryKeys } from '@/lib/query-keys/loop-planner';

export const getScenarioQueryOptions = ({
  loopId,
  scenarioId,
}: {
  loopId: number;
  scenarioId: number;
}) =>
  queryOptions({
    queryKey: loopPlannerQueryKeys.scenarios.detail({ loopId, scenarioId }),
    queryFn: () => LoopPlannerScenarioApi.getScenario({ loopId, scenarioId, includeMetrics: true }),
    staleTime: 0,
    refetchOnWindowFocus: true,
  });

export const useGetScenario = ({ loopId, scenarioId }: { loopId: number; scenarioId: number }) => {
  return useQuery(getScenarioQueryOptions({ loopId, scenarioId }));
};

export const useGetScenarioSuspense = ({
  loopId,
  scenarioId,
}: {
  loopId: number;
  scenarioId: number;
}) => {
  return useSuspenseQuery(getScenarioQueryOptions({ loopId, scenarioId }));
};
